import { render } from "./AttrHTML.vue?vue&type=template&id=2849eb9a&scoped=true"
import script from "./AttrHTML.vue?vue&type=script&lang=js"
export * from "./AttrHTML.vue?vue&type=script&lang=js"

import "./AttrHTML.vue?vue&type=style&index=0&id=2849eb9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2849eb9a"],['__file',"src/components/widgets/components_core/AttrHTML.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2849eb9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2849eb9a', __exports__)) {
    api.reload('2849eb9a', __exports__)
  }
  
  module.hot.accept("./AttrHTML.vue?vue&type=template&id=2849eb9a&scoped=true", () => {
    api.rerender('2849eb9a', render)
  })

}


export default __exports__